import CollapsableSection, { ICON_SIZE } from './CollapsableSection';

export default CollapsableSection;
export { ICON_SIZE };
